import DepartmentSelect from '@/components/Form/Shared/DepartmentSelect'
import PositionSelect from '@/components/Form/Shared/PositionSelect'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { useMutationWithHandler } from '@/hooks/useMutationWithHandler'
import { updateEmployeeDepartmentPosition } from '@/modules/Employee/services'
import { Employee } from '@/modules/Employee/types/response'
import React from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { GridHookForm, Typogaphy } from 'vnetwork-ui'

const DepartmentPosition: React.FC<{
    employee?: Employee
}> = ({ employee }) => {
    const { t } = useTranslation()
    const formControl = useForm<any>({
        defaultValues: {
            department_id: employee?.department_id,
            position_id: employee?.position_id,
        },
    })

    const { mutateAsync: updateEmployeeDepartmentPositionMutation } =
        useMutationWithHandler(
            {
                mutationFn: updateEmployeeDepartmentPosition,
            },
            {
                reactQueryKeys: QUERY_KEYS.EMPLOYEES,
                successMessage: 'employee_department_position_update_success',
                errorMessage: 'error-occurred',
            }
        )

    return (
        <div className="border-b border-b-gray-200 pb-4">
            <Typogaphy className="font-medium mb-4">
                {t('department-and-position')}
            </Typogaphy>
            <GridHookForm
                data={[
                    {
                        // Use DepartmentSelect (FilterSelect-based) for consistency with PositionSelect
                        renderEditComponent: (control) => (
                            <DepartmentSelect
                                control={control}
                                name="department_id"
                                showClearButton={false}
                                onChangeAfterHookForm={() =>
                                    formControl.setValue('position_id', 0)
                                }
                            />
                        ),
                        className: 'col-span-2',
                    },
                    {
                        renderEditComponent: (control) => (
                            <PositionSelect
                                control={control}
                                departmentId={formControl.watch(
                                    'department_id'
                                )}
                                name="position_id"
                            />
                        ),
                        className: 'col-span-2',
                    },
                ]}
                actions={[
                    {
                        title: t('save-changes'),
                        type: 'submit',
                        variant: 'contained',
                        disabled: !formControl.formState.isDirty,
                    },
                ]}
                formControl={formControl}
                onSubmit={(values) => {
                    updateEmployeeDepartmentPositionMutation({
                        employee_id: employee?.employee_id || 0,
                        department_id: values.department_id,
                        position_id: values.position_id,
                    })
                }}
            />
        </div>
    )
}

export default DepartmentPosition
